import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  loginToAuthControl,
  validateToken,
  loginSuccess,
  loginFailure
} from './redux/authSlice';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Login from './components/auth/Login';
import SignUp from './components/auth/SignUp';
import MainLayout from './layouts/MainLayout';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, CircularProgress } from '@mui/material';
import AppTheme from './AppTheme';
import './App.css';
import AppConfig from './AppConfig';
import Dashboard from './containers/Dashboard';
import LedgerController from './containers/LedgerController';
import Depository from './containers/Depository';
import Request from './containers/Request';
import { AppDataProvider } from './redux/appDataProvider';
import Tradebook from './containers/Tradebook';
import PandL from './containers/pandl';
// New component - 20/11/24 - Srini
import Version from './components/Version';
import ActiveFnO from "./containers/FAndO/ActivateFnO";
import AddNominee from './containers/Nominee/AddNominee';
import AccountClosure from './containers/AccountClosure/AccountClosureForm';
import UserProfile from './containers/UserProfile/UserProfile'; // srini - 24-07-25
import POAActivation from './containers/ActivatePoa/ActivatePoa';
import { resetBankStates } from './redux/authSlice';
import { useNavigate } from 'react-router-dom';
import Contract from './containers/Contract/Contract';

let authtype
let authpage

const App = () => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.auth.userId !== null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {

    const login = async (authToken, userId, authtype, authpage) => {
      try {
        const validateTokenResponse = await dispatch(validateToken({ authToken, userId, authtype, authpage }));

        if (validateTokenResponse.payload && validateTokenResponse.payload.success) {
          //Commented by dev-trupti to check the XTS token login - 1
          const authControlResponse = await dispatch(loginToAuthControl({ authToken: validateTokenResponse.payload.token, userId }));
          if (authControlResponse.payload && authControlResponse.payload.success) {
            dispatch(loginSuccess(validateTokenResponse.payload));
            AppConfig.removeQueryParams();

          } else {

            dispatch(loginFailure('Error validating token'));
          }
        } else {
          dispatch(loginFailure('Login failed'));
          // Token expiry handled - 23-08-24 - Dev Srini
          setTimeout(() => {
            localStorage.clear();
            window.location.replace("/")
            localStorage.setItem("sessionExpired", "Login failed")
          }, 1000);
        }
      } catch (error) {
        console.error('Error during login:', error);
        dispatch(loginFailure('Error during login'));
      }
    };

    const authenticateUser = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const authToken = urlParams.get('token');
      const userId = urlParams.get('userID');
      authtype = urlParams.get('type');
      authpage = urlParams.get('RequestPage')

      console.log(authToken,"authToken")
      console.log(userId,"userId")
      console.log(authtype,"authtype")
      console.log(authpage,"authpage")

      if (authToken && userId) {
        await login(authToken, userId, authtype, authpage);
      }
      setIsLoading(false);
    };
    authenticateUser();

  }, [dispatch]);




  if (isLoading) {
    return (
      <div className="main-app-progress">
        <CircularProgress />
      </div>
    );
  }

  if (!isAuthenticated) {
    //  window.location.replace(AppConfig.appRedirectUrl);

    return null

  }

  return (
    <ThemeProvider theme={AppTheme}>
      <CssBaseline enableColorScheme />
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/dashboard" element={<ProtectedRoute />}>
            <Route path="addfunds" element={<ProtectedRoute />} />
            <Route path="withdraw" element={<ProtectedRoute />} />
            <Route path="marginpledge" element={<ProtectedRoute />} />
            <Route path="fundtransferstatus" element={<ProtectedRoute />} />
          </Route>
          <Route path="/ledger" element={<ProtectedRoute />} />
          <Route path="/depository" element={<ProtectedRoute />} />
          <Route path="/manage-accounts/bankaccount" element={<ProtectedRoute />} />
          <Route path="/tradebook" element={<ProtectedRoute />} />
          <Route path="/pandl" element={<ProtectedRoute />} />
          {/* New component render - 20/11/24 - Srini */}

          <Route path="/manage-accounts/activatefno" element={<ProtectedRoute />} />
          <Route path="/manage-accounts/account-closure" element={<ProtectedRoute />} />
          <Route path="/vers" element={<Version />} />
          <Route path="/manage-accounts/addnominee" element={<ProtectedRoute />} />
          <Route path="/manage-accounts/myprofile" element={<ProtectedRoute />} />
          <Route path="/manage-accounts/poa" element={<ProtectedRoute />} />
          <Route path="/report" element={<ProtectedRoute />} />
          
        </Routes>
      </Router>
    </ThemeProvider>
  );
};

const ProtectedRoute = () => {
  return <AuthenticatedApp />;
};


const AuthenticatedApp = () => {
  const location = useLocation();
  const [selectedItem, setSelectedItem] = useState('Dashboard');
  // Update selectedItem state based on current location
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    console.log(`location ${location.pathname}`);
    let p = location.pathname
    const urlParams = new URLSearchParams(window.location.search);

    console.log('authtype', authtype)
    console.log('authpage', authpage)

    if (authtype === "XTSPAYIN") {
      p = '/dashboard/addfunds'
    }

    if (authtype === "XTSPAYOUT") {
      p = '/dashboard/withdraw'
    }

    if (authtype === "XTS" && authpage === "paystatus") {
      p = '/dashboard/fundtransferstatus'
    }

    switch (p) {
      case '/dashboard':
        dispatch(resetBankStates())
        setSelectedItem('Dashboard');
        break;
      case '/ledger':
        setSelectedItem('Ledger');
        break;
      case '/depository':
        setSelectedItem('Depository');
        break;
      case '/tradebook':
        setSelectedItem('Tradebook');
        break;
      case '/pandl':
        setSelectedItem('PandL');
        break;
      case '/manage-accounts/activatefno':
        setSelectedItem("ActivateFnO");
        break;
      case '/manage-accounts/account-closure':
        setSelectedItem("AccountClosure")
        break;
      case '/manage-accounts/bankaccount':
        setSelectedItem('BankAccount');
        break
      case '/manage-accounts/myprofile':
        setSelectedItem('MyProfile');
        break
      case '/manage-accounts/poa':
        setSelectedItem("ActivatePoa")
        break;
      case '/manage-accounts/addnominee':
        setSelectedItem('AddNominee');
        break;
       case '/report':
        setSelectedItem('Report');
        break;
      case '/dashboard/addfunds':

        authtype = ""
        setSelectedItem('AddFunds');
        navigate('/dashboard/addfunds?' + urlParams);

        break;
      case '/dashboard/withdraw':
        navigate('/dashboard/withdraw?' + urlParams);
        authtype = ""
        setSelectedItem('Withdraw');
        break;
      case '/dashboard/marginpledge':

        setSelectedItem('MarginPledge');
        break;
      case '/dashboard/fundtransferstatus':
        authtype = ""
        setSelectedItem('FundTransferStatus');
        navigate('/dashboard/fundtransferstatus');
      default:
        setSelectedItem('Dashboard');
        break;
    };
  }, [location.pathname]);

  return (
    <AppDataProvider>
      <MainLayout selectedItem={selectedItem} section={selectedItem.toLocaleLowerCase()}>
        <Routes>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/dashboard/addfunds" element={<Dashboard />} />
          <Route path="/dashboard/withdraw" element={<Dashboard />} />
          <Route path="/dashboard/marginpledge" element={<Dashboard />} />
          <Route path="/dashboard/fundtransferstatus" element={<Dashboard />} />
          <Route path="/ledger" element={<LedgerController />} />
          <Route path="/depository" element={<Depository />} />
          <Route path="/manage-accounts/bankaccount" element={<Request />} />
          <Route path="/tradebook" element={<Tradebook />} />
          <Route path="/pandl" element={<ProtectedRoute />} />
          <Route path="/manage-accounts/activatefno" element={<ActiveFnO />} />
          <Route path="/manage-accounts/account-closure" element={<AccountClosure />} />
          {/* Add more routes for other pages */}
          <Route path="/manage-accounts/addnominee" element={<AddNominee />} />
          <Route path="/manage-accounts/myprofile" element={<UserProfile />} />
                    <Route path="/manage-accounts/poa" element={<POAActivation />} />
          <Route path="/report" element={<Contract />} />


        </Routes>
      </MainLayout>
    </AppDataProvider>
  );
};


export default App;
